import { api } from './client';
import type { RoomNotificationDto } from './types';

export const roomNotificationsApi = {
  mine: () => api.get<RoomNotificationDto[]>('/me/room-notifications'),
  count: () => api.get<{ count: number }>('/me/room-notifications/count'),
  dismiss: (id: string) => api.post<void>(`/me/room-notifications/${id}/dismiss`),
};
